module.exports = __webpack_public_path__ + "img/avatar-2.47e495b8.jpg";